import { publishHttp } from '../http'

import {
  PublishAccountAuthRequestReq,
  PublishAccountAuthRequestRes,
  PublishAccountAuthGrantReq,
  PublishAccountAuthGrantRes,
  PublishAccountRefreshTokenReq,
  PublishAccountRefreshTokenRes,
  PublishAccountThirdLoginReq,
  PublishAccountThirdLoginRes,
  PublishAccountSsoAuthReq,
  PublishAccountAuthExchangeReq,
  PublishAccountAuthExchangeRes,
  PublishAccountLoginChannelStatusReq,
  PublishAccountLoginChannelStatusRes,
} from './types/publish'

// 授权请求
export const publishAccountAuthRequest = (data: PublishAccountAuthRequestReq) => {
  return publishHttp.post<PublishAccountAuthRequestRes>('/account/auth/request', data)
}

// 授权确认
export const publishAccountAuthGrant = (data: PublishAccountAuthGrantReq) => {
  return publishHttp.post<PublishAccountAuthGrantRes>('/account/auth/grant', data)
}

// 刷新token
export const publishAccountRefreshToken = (data: PublishAccountRefreshTokenReq) => {
  return publishHttp.post<PublishAccountRefreshTokenRes>('/account/auth/refresh', data)
}

// 授权清除
export const publishAccountAuthClear = (access_token: string) => {
  return publishHttp.post('/account/auth/clear', { access_token })
}

// 第三方登录
export const publishAccountThirdLogin = (data: PublishAccountThirdLoginReq) => {
  return publishHttp.post<PublishAccountThirdLoginRes>('/account/auth/third_login', data)
}

// sso授权
export const publishAccountSsoAuth = (data: PublishAccountSsoAuthReq) => {
  return publishHttp.post<PublishAccountAuthGrantRes>('/account/auth/sso', data)
}

// 交换access token
export const publishAccountAuthExchange = (data: PublishAccountAuthExchangeReq) => {
  return publishHttp.post<PublishAccountAuthExchangeRes>('/account/auth/exchange', data)
}

// 获取应用登录渠道状态
export const publishAccountLoginChannelStatus = (data: PublishAccountLoginChannelStatusReq) => {
  return publishHttp.post<PublishAccountLoginChannelStatusRes>('/account/auth/login_channel_status', data)
}
